var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_48_place_holder",
    "data-name": "Icon/48 place holder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icon_48_place_holder_style_",
    "data-name": "Icon/48 place holder (style)",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#e778af",
    opacity: 0.305
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_activity_filled",
    "data-name": "UI icon/activity/filled",
    transform: "translate(13.999 14.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_605_Stroke_",
    "data-name": "Vector 605 (Stroke)",
    d: "M7.489,2.4a.5.5,0,0,0-.978,0L5.317,7.97a3,3,0,0,1-2.933,2.371H1a1,1,0,0,1,0-2H2.383a1,1,0,0,0,.978-.79L4.555,1.976a2.5,2.5,0,0,1,4.889,0l3.067,14.311a.5.5,0,0,0,.978,0l1.194-5.574a3,3,0,0,1,2.933-2.371H19a1,1,0,0,1,0,2H17.617a1,1,0,0,0-.978.79l-1.194,5.574a2.5,2.5,0,0,1-4.889,0Z",
    transform: "translate(0 0)",
    fill: "#33383f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/income.edb47d2bba56245f165b9f1f88ca8879.svg";
export { ForwardRef as ReactComponent };